import { Box } from '@chakra-ui/react';
import { type SwitchProps } from '@chakra-ui/react';

const BuilderSwitch = (props: SwitchProps) => {
  const { isChecked, isDisabled, ...rest } = props;

  const trackBg = isDisabled
    ? 'rgba(221, 221, 221, 0.87)'
    : isChecked
      ? '#505E69'
      : 'rgba(80, 94, 105, 0.5)';

  const thumbBg = isDisabled ? '#F8F8F8' : 'white';

  return (
    <Box
      as="button"
      type="button"
      role="switch"
      aria-checked={isChecked}
      disabled={isDisabled}
      onClick={() => {
        if (!isDisabled && rest.onChange) {
          rest.onChange({ target: { checked: !isChecked } } as any);
        }
      }}
      onFocus={rest.onFocus as any}
      onBlur={rest.onBlur as any}
      position="relative"
      w="36px"
      h="20px"
      borderRadius="100px"
      bg={trackBg}
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      transition="background 0.2s"
      flexShrink={0}
      _focus={{ boxShadow: 'none', outline: 'none' }}
    >
      <Box
        position="absolute"
        top="2px"
        left={isChecked ? '18px' : '2px'}
        w="16px"
        h="16px"
        borderRadius="100px"
        bg={thumbBg}
        boxShadow="0px 2px 4px rgba(39, 39, 39, 0.1)"
        transition="left 0.2s"
      />
    </Box>
  );
};

export default BuilderSwitch;
